/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { TextInput, ActionButton, AlertBar } from '@blend/enterprise-components';
import { Redirect } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import { getLoan } from 'blb-api/loans';

export const styles = StyleSheet.create({
  buttonWrapper: {
    marginTop: '5px',
  },
  centeredContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    position: 'absolute',
    width: '100%',
  },
  error: {
    color: 'red',
    marginBottom: '5px',
  },
  formWrapper: {
    width: 400,
  },
});

export namespace QCSearchPage {
  export interface Props {}
}

interface Error {
  status?: number;
}

interface FetchedLoan {
  id?: string;
}

export const QCSearchPage: React.FC<QCSearchPage.Props> = ({}) => {
  const [query, setQuery] = React.useState<string>('');
  const [fetchedLoan, setLoan] = React.useState<FetchedLoan>({});
  const [loanError, setLoanError] = React.useState<Error | undefined>(undefined);
  const loanErrorMessage =
    loanError?.status === 404 ? 'We could not find a loan with that loanId.' : 'Internal server error';
  const handleSearch = (e: React.SyntheticEvent) => {
    e.preventDefault();
    getLoan(query)
      .then(loan => {
        setLoan({ id: loan.data.loanId });
      })
      .catch(error => {
        const statusCode = error.response.status;
        if (statusCode !== 404) {
          Sentry.captureException(error);
        }
        setLoanError(error.response);
      });
  };

  return (
    <div className={css(styles.centeredContainer)}>
      <form className={css(styles.formWrapper)} onSubmit={handleSearch}>
        {loanError && (
          <div className={css(styles.error)}>
            <AlertBar message={loanErrorMessage} theme={'error'} />
          </div>
        )}
        <TextInput
          configOverrides={{
            icon: {
              position: 'left',
              size: 16,
              type: 'search',
            },
          }}
          onChange={e => setQuery(e.target.value)}
          placeholder="Search for a loan by loan Id"
          type="search"
          value={query}
        />
        <div className={css(styles.buttonWrapper)}>
          <ActionButton label={'Search'} type="submit" />
        </div>
      </form>
      {fetchedLoan.id && <Redirect to={`${fetchedLoan.id}/dashboard`} />}
    </div>
  );
};
